// import BaiduMap from "@/utils/baidu-map.js";

const greenMarker = new BMap.Symbol(BMap_Symbol_SHAPE_POINT, {
  scale: 1,//图标缩放大小
  fillColor: "#1afa29",//填充颜色
  fillOpacity: 1,//填充透明度
  strokeOpacity:1, //线透明度
  strokeColor:'#1afa29'
})
const redMarker = new BMap.Symbol(BMap_Symbol_SHAPE_POINT, {
  scale: 1,//图标缩放大小
  fillColor: "#d81e06",//填充颜色
  fillOpacity: 1,//填充透明度
  strokeOpacity:1, //线透明度
  strokeColor:'#d81e06'
})
const yellowMarker = new BMap.Symbol(BMap_Symbol_SHAPE_POINT, {
  scale: 1,//图标缩放大小
  fillColor: "#f4ea2a",//填充颜色
  fillOpacity: 1,//填充透明度
  strokeOpacity:1, //线透明度,
  strokeColor:"#f4ea2a"
})
const blueMarker = new BMap.Symbol(BMap_Symbol_SHAPE_POINT, {
  scale: 1,//图标缩放大小
  fillColor: "#1296db",//填充颜色
  fillOpacity: 1,//填充透明度
  strokeOpacity:1, //线透明度
  strokeColor:"#1296db"
})
const deepblueMarker = new BMap.Symbol(BMap_Symbol_SHAPE_POINT, {
  scale: 1,//图标缩放大小
  fillColor: "#13227a",//填充颜色
  fillOpacity: 1,//填充透明度
  strokeOpacity:1, //线透明度
  strokeColor:"#13227a"
})
const blackMarker = new BMap.Symbol(BMap_Symbol_SHAPE_POINT, {
  scale: 1,//图标缩放大小
  fillColor: "#000",//填充颜色
  fillOpacity: 1,//填充透明度
  strokeOpacity:1, //线透明度
  strokeColor:"#000"
})
const ownerList = [
  {
    name: "靖边国兴丝路综合能源服务有限公司,18091252635",
    phone: "18091252635",
    codeStr: "14b43a9b5e",
  },
  {
    name: "靖边国兴丝路综合能源服务有限公司2,13259333365",
    phone: "13259333365",
    codeStr: "475644448f",
  },
  {
    name: "靖边国兴丝路综合能源服务有限公司,18900868526",
    phone: "18900868526",
    codeStr: "b1aba93220",
  },
  {
    name: "八亿科技有限公司,18161937179",
    phone: "18161937179",
    codeStr: "0d70ee8bd4",
  },
  {
    name: "八亿科技有限公司1,15891133855",
    phone: "15891133855",
    codeStr: "ab11720c18",
  },
  {
    name: "八亿科技有限公司2,13891295693",
    phone: "13891295693",
    codeStr: "237ac02e07",
  },
  {
    name: "八亿能源供应链有限公司,15091506816",
    phone: "15091506816",
    codeStr: "0e27b32e8c",
  },
  {
    name: "八亿能源供应链有限公司1,18091272635",
    phone: "18091272635",
    codeStr: "e637455c66",
  },
  {
    name: "榆林市福运能源供应有限公司,13891276809",
    phone: "13891276809",
    codeStr: "9341e237bf",
  },
  {
    name: "榆林市福运能源供应有限公司1,18291210222",
    phone: "18291210222",
    codeStr: "2de324366e",
  },
  {
    name: "榆林市福运能源供应有限公司3,15389120111",
    phone: "15389120111",
    codeStr: "ce19d66b8d",
  },
  {
    name:'陕西华兴丝路供应链管理有限公司,13474482838',
    phone:'13474482838',
    codeStr:'a547cf576e'
  }
];

const tonSettleType = {
  1: "装货吨位",
  2: "卸货吨位",
  3: "装、卸最小吨位",
}

const feeEnum = {
  carriageUnitPrice: "运价",
  loadingTon: "装货吨位",
  unloadingTon: "卸货吨位",
}

const settleTypeList = {
  5: "运输中",
  10: "已卸货",
  15: "待审核",
  20: "待付款",
  25: "已付款",
  30: "已取消",
  35: "已驳回",
  40: "审核传参失败"
}

const dispatchSubject = {
  JBB: "靖边国兴丝路综合能源服务有限公司",
  BY: "八亿科技有限公司",
  BY_GYL: "八亿供应链有限公司",
  FY: "榆林市福运能源供应有限公司",
}

const unitType = {
  "carriageUnitPrice":'元/吨',
  "carriage":'元',
  "loadingTon":'吨',
  "unloadingTon":'吨'
}

const operationTypeList =['手动补扣款','审核驳回','取消结算']

const purchaseTypeObj = {
  0:'自采',
  1:'代采',
  2:'公转铁',
  3:'保供'
}

const uploadTypeList = [{code:1,name:'系统自动上传'},{code:2,name:'司机手动上传'}]
export  {
  ownerList,
  tonSettleType,
  feeEnum,
  settleTypeList,
  dispatchSubject,
  unitType,
  operationTypeList,
  purchaseTypeObj,
  greenMarker,
  redMarker,
  yellowMarker,
  blueMarker,
  deepblueMarker,
  blackMarker,
  uploadTypeList
}